// extracted by mini-css-extract-plugin
export default {"selectContent":"styles_selectContent__5uio2","label":"styles_label__etW7H","select":"styles_select__0YuX+"};